// QuoteDetailPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { SecondaryLoadingScreen } from '../../LoadingScreen';
import { toast, ToastContainer } from 'react-toastify';
import { QuoteStatusCell } from '../../ExternalComponent';
import { useRecentOrdersContext } from '../../../Context/Cache/RecentOrder/RecentOrdersContext';
import { FaFileExport } from "react-icons/fa6";
import { HiRefresh } from "react-icons/hi";
import { FaHistory } from "react-icons/fa";
import deleteIcon from "../../Assets/icon/delete.png";
import ExcelJS from 'exceljs';
import { useNavigate } from "react-router-dom";
import { useCartInventoryContext } from '../../../Context/Cache/CartInventoryContext';
import { Tooltip } from "@mui/material";

const columns = [
  // Amit 02-08-2024
  { key: "status", label: "Status", width: "80px" },
  { key: "sku", label: "SKU", width: "80px" },
  { key: "upcNumber", label: "UPC", width: "140px" },
  // { key: "image", label: "Image", width: "80px" },
  { key: "brand", label: "Brand", width: "100px" },
  { key: "productName", label: "Product Name", width: "200px" },
  { key: "color", label: "Color", width: "70px" },
  { key: "size", label: "Size(with UOM)", width: "70px" },
  { key: "availableQuantity", label: "Available Quantity", width: "70px" },
  { key: "requestedQuantity", label: "Requested Quantity", width: "150px" },
  { key: "price", label: "Price", width: "80px" },
  { key: "counterOffer", label: "Offer Price", width: "150px" },
  { key: "lastModifiedBy", label: "Last Modified By", width: "150px" },
  { key: "lastModified", label: "Last Modified On", width: "100px" },
  { key: "comments", label: "Comments", width: "150px" },
  { key: "history", label: "History", width: "100px" }
];

const QuoteDetailPage = ({ quoteId, quoteType, quoteNumber, onClose }) => {
  const { products, atuProducts } = useRecentOrdersContext()
  const navigate = useNavigate();
  const { editOrder, setEditOrder } = useCartInventoryContext();
  console.log("productssss", products)
  console.log("Atu Product", atuProducts)
  const [productLines, setProductLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quoteStatus, setQuoteStatus] = useState([])
  const [statusInfo, setStatusInfo] = useState({ text: "Unknown Status", color: "gray" });
  // const [visibleColumns, setVisibleColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(
    columns.map((col) => col.key)
  );
  const [exportExcelName, setExportExcelName] = useState(null);
  const [formData, setFormData] = useState([]);
  const hiddenColumns = (quoteType === 0)
    ? ["sku", "counterOffer"]
    : [];
  const [total, setTotal] = useState(0);
  const [hasChanged, setHasChanged] = useState(false);

  console.log("Quote Id", quoteId)
  console.log("Quote Type", quoteType)
  // Hide and show
  const toggleColumnVisibility = (key) => {
    setVisibleColumns((prevState) =>
      prevState.includes(key)
        ? prevState.filter((col) => col !== key)
        : [...prevState, key]
    );
  };

  const toggleAllColumns = () => {
    if (visibleColumns.length === columns.length) {
      setVisibleColumns([]);
    } else {
      setVisibleColumns(columns.map((col) => col.key));
    }
  };

  // Update formData whenever productLines change
  useEffect(() => {
    setFormData(
      productLines.map(line => ({
        quotedetailid: line.quotedetailid,
        quoteid: line.quoteid,
        productId: line.productId,
        sku: line.nyc_sku,
        quantity: line.quantity || '',
        counterOffer: line.counterOffer || '',
      }))
    );
  }, [productLines]);

  const handleInputChange = (index, field, value) => {
    const updatedData = [...formData];

    if (field === 'quantity') {
      const availableQuantity = productLines[index]?.nyc_availablequantity;

      // Allow only non-negative integers and ensure it doesn't exceed available quantity
      if (/^\d*$/.test(value)) {
        if (Number(value) <= availableQuantity) {
          if (updatedData[index]) {
            updatedData[index][field] = value;
            updatedData[index].modified = true; // Mark as modified
            setFormData(updatedData);
            setHasChanged(true);
            calculateTotal(updatedData, productLines); // Calculate total after value change
          }
        } else {
          toast.error(`Quantity cannot exceed available quantity of ${availableQuantity}`);
        }
      }
    } else if (field === 'counterOffer') {
      if (/^\d*\.?\d*$/.test(value)) {
        if (updatedData[index]) {
          updatedData[index][field] = value;
          updatedData[index].modified = true; // Mark as modified
          setFormData(updatedData);
          setHasChanged(true);
          calculateTotal(updatedData, productLines); // Calculate total after value change
        }
      }
    }
  };

  const performActionBasedOnChange = () => {
    if (quoteStatus !== 219640001) {
      toast.warning("You do not have permission to make changes as the offer is currently being reviewed by Salesperson")
      return
    }
    if (hasChanged) {
      // Call this function if `hasChanged` is true
      handleSubmit()
    } else {
      handleUnmodifiedAction();
    }
  };

  const handleUnmodifiedAction = async () => {
    if (!quoteId) {
      toast.error('Please provide a Offer ID'); // Show error toast if no quote ID
      return;
    }
    setLoading(true); // Start loading state

    try {
      const response = await axios.patch(`${process.env.REACT_APP_SERVER_URL}/api/quote/update-quote-negotiation`, {
        quoteid: quoteId,
      });

      // Check if the response is successful based on the success field
      if (response.data.success) {
        toast.success(response.data.message || 'Offer updated successfully'); // Show success toast
        await fetchQuoteData();
        await fetchQuoteDetails();
        onClose()
      } else {
        toast.error(response.data.message || 'Failed to update the Offer'); // Show error toast based on success: false
      }
    } catch (error) {
      toast.error(`Error: ${error.response?.data?.message || error.message}`); // Show error toast on catch
    } finally {
      setLoading(false); // End loading state
    }
  };


  // const handleInputChange = (index, field, value) => {
  //   const updatedData = [...formData];

  //   if (field === 'quantity') {
  //     const availableQuantity = productLines[index]?.nyc_availablequantity;

  //     // Allow only non-negative integers and ensure it doesn't exceed available quantity
  //     if (/^\d*$/.test(value)) {
  //       if (Number(value) <= availableQuantity) {
  //         if (updatedData[index]) {
  //           updatedData[index][field] = value;
  //           setFormData(updatedData);
  //           calculateTotal(updatedData, productLines); // Calculate total after value change
  //         }
  //       } else {
  //         toast.error(`Quantity cannot exceed available quantity of ${availableQuantity}`);
  //       }
  //     }
  //   } else if (field === 'counterOffer') {
  //     if (/^\d*\.?\d*$/.test(value)) {
  //       if (updatedData[index]) {
  //         updatedData[index][field] = value;
  //         setFormData(updatedData);
  //         calculateTotal(updatedData, productLines); // Calculate total after value change
  //       }
  //     }
  //   }
  // };

  const calculateTotal = (updatedData = [], productLines = []) => {
    let newTotal = 0;

    if (!Array.isArray(updatedData) || !Array.isArray(productLines)) return; // Guard clause to handle undefined values

    updatedData.forEach((item, index) => {
      const productLine = productLines[index];

      const quantity = Number(item.quantity) || 0; // Handle empty quantity as 0

      if (quoteType === 1) {
        const counterOffer = Number(item.counterOffer) || 0; // Handle empty counterOffer as 0
        newTotal += quantity * counterOffer;
      } else if (quoteType === 0) {
        const price = Number(productLine?.pricePerUnit) || 0; // Handle missing price as 0
        newTotal += quantity * price;
      }
    });

    setTotal(newTotal); // Update total state
  };

  useEffect(() => {
    if (formData.length > 0 && productLines.length > 0) {
      calculateTotal(formData, productLines); // Ensure arguments are passed
    }
  }, [formData, productLines]);



  const handleKeyDownQuentity = (e) => {
    // Prevent entering negative sign or decimal point in quantity input
    if (e.key === '-' || e.key === '.' || e.key === 'e') {
      e.preventDefault();
    }
  };

  const handleKeyDownOffer = (e) => {
    // Prevent entering negative sign or decimal point in quantity input
    if (e.key === '-' || e.key === 'e') {
      e.preventDefault();
    }
  };


  const fetchQuoteData = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/quote/quotes-negotiationStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quoteId: quoteId,
      }),
    });

    const data = await response.json();
    setQuoteStatus(data.nyc_negotiationstages)
  };

  useEffect(() => {
    fetchQuoteData();
  }, [quoteId])

  // const fetchQuoteDetails = async () => {
  //   setLoading(true)
  //   try {
  //     console.log("Function Call");
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_URL}/api/quote/product-lines`,
  //       { quoteId, quoteType }
  //     );
  //     console.log("Response Data:", response.data);

  //     // Choose the product source based on quoteType
  //     const productSource = quoteType === 0 ? atuProducts : products;

  //     console.log("Product Source", productSource)

  //     // Map through the quote lines and enrich them with product data from the selected source
  //     const enrichedProductLines = response.data.map(quoteLine => {
  //       const product = getProductFromCache(quoteLine.productId, productSource, quoteType);
  //       console.log("Inside Product", product)

  //       if (product) {
  //         // Conditionally map fields based on the product source
  //         if (quoteType === 0) {
  //           // Enrich with fields from atuProducts (checking nyc_atuid)
  //           return {
  //             ...quoteLine,
  //             // atu_brand: product.atu_brand,  // Example specific to atuProducts
  //             nyc_sku: product.nyc_sku,
  //             nyc_upc: product.nyc_upc,
  //             nyc_color: product.nyc_name,  // Example specific to atuProducts
  //             nyc_size: product.nyc_size,
  //             nyc_availablequantity: product.nyc_availablequantity,
  //             pricePerUnit: product.nyc_price,
  //           };
  //         } else {
  //           // Enrich with fields from products (checking productid)
  //           return {
  //             ...quoteLine,
  //             nyc_sku: product.productnumber,
  //             nyc_brand: product.nyc_brand,  // Example field for products
  //             nyc_color: product.nyc_color,  // Example field for products
  //             nyc_size: product.size,
  //             nyc_upc: product.nyc_upc,
  //             nyc_sizeuom: product.nyc_sizeuom,
  //             nyc_availablequantity: product.strava_availablequantity,
  //             pricePerUnit: product.price
  //           };
  //         }
  //       } else {
  //         return quoteLine; // No matching product, return original quoteLine
  //       }
  //     });

  //     // Set the enriched product lines
  //     setProductLines(enrichedProductLines);
  //     setLoading(false)
  //   } catch (err) {
  //     setError('Failed to fetch quote details');
  //     setLoading(false)
  //     console.error('Error fetching quote details:', err);
  //   }
  // };


  const fetchQuoteDetails = async (retryCount = 3) => {
    setLoading(true);
    let attempt = 0;

    while (attempt < retryCount) {
      try {
        console.log("Function Call, Attempt:", attempt + 1);
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/api/quote/product-lines`,
          { quoteId, quoteType }
        );
        console.log("Response Data:", response.data);

        // Choose the product source based on quoteType
        const productSource = quoteType === 0 ? atuProducts : products;
        console.log("Product Source", productSource);

        // Map through the quote lines and enrich them with product data from the selected source
        const enrichedProductLines = response.data.map(quoteLine => {
          const product = getProductFromCache(quoteLine.productId, productSource, quoteType);
          console.log("Inside Product", product);

          if (product) {
            // Conditionally map fields based on the product source
            if (quoteType === 0) {
              return {
                ...quoteLine,
                nyc_sku: product.nyc_sku,
                nyc_upc: product.nyc_upc,
                nyc_color: product.nyc_name,
                nyc_size: product.nyc_size,
                nyc_availablequantity: product.nyc_availablequantity,
                pricePerUnit: product.nyc_price,
              };
            } else {
              return {
                ...quoteLine,
                nyc_sku: product.productnumber,
                nyc_brand: product.nyc_brand,
                nyc_color: product.nyc_color,
                nyc_size: product.size,
                nyc_upc: product.nyc_upc,
                nyc_sizeuom: product.nyc_sizeuom,
                nyc_availablequantity: product.strava_availablequantity,
                pricePerUnit: product.price
              };
            }
          } else {
            return quoteLine; // No matching product, return original quoteLine
          }
        });

        // Set the enriched product lines and end the retry loop
        setProductLines(enrichedProductLines);
        setLoading(false);
        return; // Exit the function after a successful response

      } catch (err) {
        attempt += 1;
        console.error(`Error fetching quote details (Attempt ${attempt}):`, err);

        if (attempt >= retryCount) {
          setError('Failed to fetch quote details after multiple attempts');
          setLoading(false);
        } else {
          console.log("Retrying to fetch quote details...");
        }
      }
    }
  };


  // Function to get the product from the correct source (atuProducts or products)
  const getProductFromCache = (productId, productSource, quoteType) => {

    console.log("Product ID", productId)
    // Check based on the quoteType
    if (quoteType === 0) {
      // For atuProducts, check against nyc_atuid
      return productSource.find(product => product.nyc_atuid === productId);
    } else {
      // For regular products, check against productid
      return productSource.find(product => product.productid === productId);
    }
  };


  useEffect(() => {
    fetchQuoteDetails();
  }, [quoteId]);

  // const deleteProduct = async (quotedetailid, quoteType) => {
  //   setLoading(true)
  //   try {
  //     const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/quote/delete-record`, {
  //       params: { quotedetailid, quoteType },
  //     });

  //     if (response.data.errorType) {
  //       // Display error toast based on errorType from the response
  //       setLoading(false)
  //       toast.error(response.data.msg || "Failed to delete record");
  //     } else {
  //       handleRefrshButton()
  //       setLoading(false)
  //       toast.success(response.data.msg || "Record deleted successfully");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting product:", error);
  //     setLoading(false)
  //     // Display generic error if an unexpected error occurs
  //     toast.error("An unexpected error occurred while deleting the record.");
  //   }
  // };

  const deleteProduct = async (quotedetailid, quoteType) => {
    setLoading(true);
    try {
      // Send the delete request with quotedetailid and quoteType as parameters
      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/api/quote/delete-record`,
        {
          params: { quotedetailid, quoteType },
        }
      );

      // Check if the response contains an errorType
      if (response.data.errorType) {
        // Display a toast based on the errorType and response message
        toast.error(response.data.msg || "Failed to delete record");
      } else {
        // Call a function to refresh data after successful deletion
        handleRefrshButton();
        // Display a success toast with the response message
        toast.success(response.data.msg || "Record deleted successfully");
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg || "Failed to delete record from server.");
      } else if (error.request) {
        toast.error("No response from server. Please try again later.");
      } else {
        toast.error("An unexpected error occurred while deleting the record.");
      }
    } finally {
      // Ensure loading state is reset regardless of outcome
      setLoading(false);
    }
  };


  const handleCounterOfferChange = (index, newValue) => {
    setProductLines((prevLines) =>
      prevLines.map((line, i) => (i === index ? { ...line, counterOffer: newValue } : line))
    );
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const filteredFormData = formData.filter(item => item.modified);

      // if (filteredFormData.length === 0) {
      //   toast.info("No changes detected or all products are already approved.");
      //   setLoading(false);
      //   return; // Early return, no need to continue
      // }

      const formDataType0 = filteredFormData.filter(
        (item, index) => productLines[index].lineItemType === 0
      );
      const formDataType1 = filteredFormData.filter(
        (item, index) => productLines[index].lineItemType === 1
      );

      // Helper function to process and validate data
      const processData = (data, type) => {
        for (let item of data) {
          if (type === 0) {
            if (parseInt(item.quantity, 10) === 0 || parseFloat(item.counterOffer) === 0) {
              toast.error(`ATU Line Item with SKU ${item.sku} has 0 value in quantity or Offer Price`);
              return null; // Early return if validation fails
            }
          } else {
            if (parseInt(item.quantity, 10) === 0 || parseFloat(item.counterOffer) === 0) {
              toast.error(`Product Line Item with SKU ${item.sku} has 0 value in quantity or Offer Price`);
              return null; // Early return if validation fails
            }
          }
        }

        // If no validation issues, map the data
        return data.map(item => {
          if (type === 0) {
            return {
              atuLineItemid: item.quotedetailid,
              quoteid: item.quoteid,
              sku: item.nyc_sku,
              details: {
                nyc_requestedquantity: parseInt(item.quantity, 10),
                nyc_quoteproductstatus: 219640002,
              }
            };
          } else {
            return {
              quotedetailid: item.quotedetailid,
              quoteid: item.quoteid,
              sku: item.nyc_sku,
              details: {
                quantity: parseInt(item.quantity, 10),
                priceperunit: parseFloat(item.counterOffer),
                nyc_quoteproductstatus: 219640002,
              }
            };
          }
        });
      };

      // Process data for both types
      const processedDataType0 = processData(formDataType0, 0);
      const processedDataType1 = processData(formDataType1, 1);

      if (processedDataType0 === null || processedDataType1 === null) {
        setLoading(false);
        return; // Early exit if validation fails
      }

      // Function to make API call
      const sendApiRequest = async (url, data) => {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
        return response.json();
      };

      // Send the data via API
      const responses = [];
      if (processedDataType0.length > 0) {
        const response0 = await sendApiRequest('/api/quote/update-atulineitem', processedDataType0);
        responses.push({ response: response0, type: 0 });
      }
      if (processedDataType1.length > 0) {
        const response1 = await sendApiRequest('/api/quote/update-quotedetails', processedDataType1);
        responses.push({ response: response1, type: 1 });
      }

      // Handle API responses
      let allSuccessful = true;
      responses.forEach(({ response, type }) => {
        if (response.success) {
          toast.success(`Offer details updated successfully`);
        } else {
          allSuccessful = false;
          toast.warning(`Update failed for ${response.message}`);
        }
      });

      if (allSuccessful) {
        await fetchQuoteData();
        await fetchQuoteDetails();
        onClose()
      }

      setLoading(false);
    } catch (error) {
      console.error('Failed to update quote details:', error);
      toast.error('Failed to update quote details. Please try again.');
      setLoading(false);
    }
  };

  // const handleSubmit = async () => {
  //   setLoading(true);

  //   try {
  //     // Filter out items that have been modified
  //     const filteredFormData = formData.filter(item => item.modified);

  //     // Split filtered form data by line item type
  //     const formDataType0 = filteredFormData.filter(
  //       (item, index) => productLines[index].lineItemType === 0
  //     );
  //     const formDataType1 = filteredFormData.filter(
  //       (item, index) => productLines[index].lineItemType === 1
  //     );

  //     // Helper function for validation and data processing
  //     const processData = (data, type) => {
  //       for (const item of data) {
  //         const isInvalid = parseInt(item.quantity, 10) === 0 || parseFloat(item.counterOffer) === 0;
  //         if (isInvalid) {
  //           const itemType = type === 0 ? "ATU Line Item" : "Product Line Item";
  //           toast.error(`${itemType} with SKU ${item.sku} has 0 value in quantity or Offer Price`);
  //           return null; // Exit early if validation fails
  //         }
  //       }

  //       // Map the data if validation passes
  //       return data.map(item => ({
  //         [type === 0 ? 'atuLineItemid' : 'quotedetailid']: item.quotedetailid,
  //         quoteid: item.quoteid,
  //         sku: item.nyc_sku,
  //         details: {
  //           [type === 0 ? 'nyc_requestedquantity' : 'quantity']: parseInt(item.quantity, 10),
  //           [type === 0 ? 'nyc_quoteproductstatus' : 'priceperunit']: type === 0
  //             ? 219640002
  //             : parseFloat(item.counterOffer),
  //           nyc_quoteproductstatus: 219640002,
  //         },
  //       }));
  //     };

  //     // Process data for both types and handle validation failure
  //     const processedDataType0 = processData(formDataType0, 0);
  //     const processedDataType1 = processData(formDataType1, 1);

  //     if (!processedDataType0 || !processedDataType1) {
  //       setLoading(false);
  //       return; // Exit if any processed data failed validation
  //     }

  //     // Function to make API calls
  //     const sendApiRequest = async (url, data) => {
  //       const response = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
  //         method: 'PATCH',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(data),
  //       });
  //       return response.json();
  //     };

  //     // Prepare API calls if there's valid data
  //     const apiPromises = [];
  //     if (processedDataType0.length > 0) {
  //       apiPromises.push(sendApiRequest('/api/atu-items/update', processedDataType0));
  //     }
  //     if (processedDataType1.length > 0) {
  //       apiPromises.push(sendApiRequest('/api/quote-items/update', processedDataType1));
  //     }

  //     // Execute API calls
  //     const responses = await Promise.all(apiPromises);

  //     // Handle API responses
  //     responses.forEach((response, index) => {
  //       if (response.success) {
  //         toast.success(`Update for ${index === 0 ? 'ATU Line Items' : 'Product Line Items'} successful`);
  //       } else {
  //         toast.error(`Failed to update ${index === 0 ? 'ATU Line Items' : 'Product Line Items'}`);
  //       }
  //     });

  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Error during form submission:', error);
  //     setError('An error occurred during submission');
  //     toast.error('An unexpected error occurred. Please try again.');
  //     setLoading(false);
  //   }
  // };



  const handleExcelExport = async () => {
    console.log("Product Lines in excel", productLines);
    const data = productLines.map((item) => {
      var tempArray = {};

      // Conditional logic based on lineItemType
      if (item.lineItemType === 0) {
        // For lineItemType 0
        // if (visibleColumns.includes("image"))
        //   tempArray.Image = {
        //     text: 'Image Link',
        //     hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`
        //   };
        if (visibleColumns.includes("status")) {
          switch (item.nyc_quoteproductstatus) {
            case 219640000:
              tempArray.Status = 'Approved';
              break;
            case 219640001:
              tempArray.Status = 'Rejected';
              break;
            default:
              tempArray.Status = 'Under Review';
              break;
          }
        }
        if (visibleColumns.includes("upcNumber"))
          tempArray.UPC = item.nyc_upc;
        if (visibleColumns.includes("brand"))
          tempArray.Brand = item.nyc_brand;
        if (visibleColumns.includes("productName"))
          tempArray["Product Name"] = item.productname;
        if (visibleColumns.includes("color"))
          tempArray.Color = item.nyc_color;
        // if (visibleColumns.includes("size"))
        //   tempArray["Size(with UOM)"] = item.nyc_size + (item.nyc_sizeuom || "");
        if (visibleColumns.includes("size")) {
          tempArray["Size(with UOM)"] = (item.nyc_size || '') + (item.nyc_sizeuom || '');
        }

        if (visibleColumns.includes("availableQuantity"))
          tempArray["Available Quantity"] = item.nyc_availablequantity;
        if (visibleColumns.includes("requestedQuantity"))
          tempArray["Requested Quantity"] = item.quantity === undefined ? "-" : item.quantity;
        if (visibleColumns.includes("price"))
          tempArray["Price"] = item.pricePerUnit === undefined ? "-" : `$ ${parseFloat(item.pricePerUnit).toFixed(2)}`;

      } else if (item.lineItemType === 1) {
        // if (visibleColumns.includes("image"))
        //   tempArray.Image = {
        //     text: 'Image Link',
        //     hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`
        //   };
        if (visibleColumns.includes("status")) {
          switch (item.nyc_quoteproductstatus) {
            case 219640000:
              tempArray.Status = 'Approved';
              break;
            case 219640001:
              tempArray.Status = 'Rejected';
              break;
            default:
              tempArray.Status = 'Under Review';
              break;
          }
        }
        if (visibleColumns.includes("sku"))
          tempArray.SKU = item.nyc_sku;
        if (visibleColumns.includes("brand"))
          tempArray.Brand = item.nyc_brand;
        if (visibleColumns.includes("upcNumber"))
          tempArray.UPC = item.nyc_upc;
        if (visibleColumns.includes("productName"))
          tempArray["Product Name"] = item.productname;
        if (visibleColumns.includes("color"))
          tempArray.Color = item.nyc_color;
        if (visibleColumns.includes("size")) {
          tempArray["Size(with UOM)"] = (item.nyc_size || '') + (item.nyc_sizeuom || '');
        }
        if (visibleColumns.includes("availableQuantity"))
          tempArray["Available Quantity"] = item.nyc_availablequantity;
        if (visibleColumns.includes("requestedQuantity"))
          tempArray["Requested Quantity"] = item.quantity === undefined ? "-" : item.quantity;
        if (visibleColumns.includes("price")) {
          tempArray["Price"] = item.pricePerUnit === undefined ? "-" : `$ ${parseFloat(item.pricePerUnit).toFixed(2)}`;
        }
        if (visibleColumns.includes("counterOffer")) {
          tempArray["Offer Price"] = item.counterOffer === undefined ? "-" : `$ ${parseFloat(item.counterOffer).toFixed(2)}`;
        }
      }

      return tempArray;
    });

    console.log("excel data", data);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    if (data[0] === undefined) {
      toast.warning("Please select some rows");
      return;
    }
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    data.forEach((item) => {
      const row = worksheet.addRow(Object.values(item));
      if (headers.indexOf('Image') !== -1) {
        const imageCell = row.getCell(headers.indexOf('Image') + 1);
        if (imageCell.value && imageCell.value.text === 'Image Link') {
          imageCell.font = { color: { argb: '550000FF' }, underline: 'single' };
        }
      }
    });
    const headerRow = worksheet.getRow(1);
    headerRow.height = 40;
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF973131' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = {
        bold: true,
        size: 12,
        color: { argb: 'FFFFFFFF' },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.height = 70;
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
          };
        });
      }
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
      });
    });

    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.value) {
          const cellValue = cell.value.toString();
          maxLength = Math.max(maxLength, cellValue.length);
        }
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    });

    const packagingColumnIndex = headers.indexOf('Packaging') + 1;
    const column = worksheet.getColumn(packagingColumnIndex);
    if (column) {
      column.width = 15;
    }
    const today = new Date();
    const pad = (num) => num.toString().padStart(2, '0');
    const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${exportExcelName == null ? "NewYorkCosmetics-OfferProductList" : exportExcelName}-${formattedDate}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  };


  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    return date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Funtion to formatCurrency
  function formatNumber(number) {
    if (isNaN(number) || number === null || number === undefined) {
      number = 0;
    }
    const formattedNumber = Number(number).toFixed(2);
    return formatNumberWithCommas(formattedNumber);
  }

  const getStatusText = (status) => {
    switch (status) {
      case 219640000:
        return { text: "Under review by salesperson", color: "#FABC3F" };
      case 219640001:
        return { text: "Under review by customer", color: "green" };
      case 219640002:
        return { text: "Negotiation Completed! For further updates, refer to Recent Orders", color: "blue" };
      default:
        return { text: "Unknown Status", color: "gray" };
    }
  };

  useEffect(() => {
    const updatedStatus = getStatusText(quoteStatus);
    setStatusInfo(updatedStatus);
  }, [quoteStatus]);


  const handleRefrshButton = async () => {
    await fetchQuoteDetails()
    await fetchQuoteData()
  }

  const handleEditOffer = (quoteNumber, quoteType, quoteId, productLines) => {
    setLoading(true);

    setEditOrder([{
      quotenumber: quoteNumber,
      quoteid: quoteId,
      quotetype: quoteType,
      productlines: productLines
    }]);

    if (quoteType === 1) {
      navigate("/home/inventory");
    }
    else if (quoteType === 0) {
      navigate("/home/replenishment");
    }

    setLoading(false);
  }

  const getOrdinal = (n) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  };


  return (
    <div className="p-2">
      <ToastContainer />
      {loading ? (
        <SecondaryLoadingScreen />
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div>
          <div className='flex justify-between items-center mb-2'>
            <h2 className="text-xl font-semibold flex gap-2 items-center justify-center">
              <span>Offer Products :</span>
              <span className='font-medium underline'>{quoteNumber}</span>
            </h2>
            <div className='flex'>
              <div className='flex gap-2'>
                <div className='flex gap-2'>
                  <p className='font-bold text-xl'>Total Price :</p>
                  <p className='font-bold text-xl'>$ {formatNumber(parseFloat(total).toFixed(2))}</p>
                </div>
                <button
                  className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
                  onClick={handleExcelExport}
                >
                  <FaFileExport />
                </button>
                <button
                  className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
                  onClick={handleRefrshButton}
                >
                  <HiRefresh />
                </button>
              </div>
            </div>
          </div>
          <div className="table-container box-border shadow-sm background-white overflow-auto" style={{ height: '400px' }}>
            <table className="table-fixed min-w-full" style={{ position: "relative" }}>
              {/* <thead>
                <tr>
                  {columns.map(col => (
                    visibleColumns.includes(col.key) && (
                      // Check if the column is in the hiddenColumns list
                      !hiddenColumns.includes(col.key) && (
                        <th
                          key={col.key}
                          style={{ width: col.width, padding: col.padding }}
                          className="cursor-pointer"
                        >
                          {col.label}
                        </th>
                      )
                    )
                  ))}
                </tr>
              </thead> */}
              <thead>
                <tr>
                  {/* Default column header */}

                  {quoteStatus === 219640001 && (
                    <th style={{ width: "50px", padding: "10px" }} className="cursor-pointer">
                    </th>
                  )}

                  {columns.map(col => (
                    visibleColumns.includes(col.key) &&
                    !hiddenColumns.includes(col.key) && (
                      <th
                        key={col.key}
                        style={{ width: col.width, padding: col.padding }}
                        className="cursor-pointer"
                      >
                        {col.label}
                      </th>
                    )
                  ))}
                </tr>
              </thead>

              <tbody>

                {productLines.map((line, index) => (
                  <tr key={`${line.productId}-${index}`} className={index % 2 === 0 ? "bg-white" : "bg-[#FFF6F6]"}>

                    {/* Conditionally show columns based on quoteType */}


                    {quoteStatus === 219640001 && (
                      <td>
                        <img
                          src={deleteIcon}
                          alt="Delete Icon"
                          className="ml-2"
                          onClick={() => deleteProduct(line.quotedetailid, quoteType)}
                          style={{ cursor: "pointer" }}
                        />
                      </td>
                    )}


                    {visibleColumns.includes("status") &&
                      (
                        <QuoteStatusCell line={line} />)}
                    {/* // <td>{line.nyc_quoteproductlabel}</td>)} */}

                    {visibleColumns.includes("sku") && quoteType === 1 && (
                      <td className="text-[#DC0A0A]" style={{ fontWeight: 700 }}>{line.nyc_sku}</td>
                    )}

                    {visibleColumns.includes("upcNumber") && (
                      <td className="text-[#DC0A0A]" style={{ fontWeight: 700 }}>{line.nyc_upc}</td>
                    )}

                    {visibleColumns.includes("brand") && (<td>{line.nyc_brand}</td>)}

                    {visibleColumns.includes("productName") && (<td>{line.productname}</td>)}

                    {visibleColumns.includes("color") && (<td>{line.nyc_color}</td>)}

                    {visibleColumns.includes("size") && (<td>{line.nyc_size} {line.nyc_sizeuom}</td>)}

                    {visibleColumns.includes("availableQuantity") && (<td>{line.nyc_availablequantity}</td>)}

                    {visibleColumns.includes("requestedQuantity") && (
                      <td>
                        {quoteStatus === 219640002 ? (
                          line.quantity // Remove the extra curly braces
                        ) : (
                          <input
                            type="number"
                            value={formData[index]?.quantity || ''}
                            onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                            onKeyDown={handleKeyDownQuentity}
                            min="0"
                            step="1"
                            className="width50"
                          // disabled={line.nyc_quoteproductstatus === 219640000}
                          />
                        )}
                      </td>
                    )}

                    {visibleColumns.includes("price") && (
                      <td>
                        {line.pricePerUnit ? `$${formatNumber(parseFloat(line.pricePerUnit).toFixed(2))}` : '-'}
                      </td>
                    )}

                    {visibleColumns.includes("counterOffer") && quoteType !== 0 && (
                      <td>
                        {quoteStatus === 219640002 ? (
                          line.counterOffer // Remove the extra curly braces
                        ) : (
                          <input
                            type="number"
                            value={formData[index]?.counterOffer || ''}
                            onChange={(e) => handleInputChange(index, 'counterOffer', e.target.value)}
                            onKeyDown={handleKeyDownOffer}
                            min="0"
                            step="0.01"
                            className="width50"
                          // disabled={line.nyc_quoteproductstatus === 219640000}
                          />
                        )}

                      </td>
                    )}
                    {
                      visibleColumns.includes("lastModifiedBy") && (
                        <td>
                          {quoteStatus === 219640000 ? "Customer" : line.nyc_lastModifiedBy}
                        </td>
                      )
                    }
                    {visibleColumns.includes("lastModified") && (<td>{formatDate(line.nyc_lastModified)}</td>)}
                    {visibleColumns.includes("comments") && (<td>{line.nyc_comments}</td>)}

                    {/* {visibleColumns.includes('history') && (
                      <td>
                        <Tooltip
                          title={
                            <table style={{ borderCollapse: "collapse", width: "100%", background: "#ffffff" }}>
                              <thead>
                                <tr style={{ color: "#000000" }}>
                                  <th style={{ borderRight: "1px solid #ccc", padding: "4px 6px" }}>Bid</th>
                                  <th style={{ borderRight: "1px solid #ccc", padding: "4px" }}>You</th>
                                  <th style={{ padding: "4px" }}>Sales Person</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(() => {
                                  const customerBids = typeof line.nyc_customerbid === "string" ? line.nyc_customerbid.split('/') : [];
                                  const salespersonBids = typeof line.nyc_salespersonbid === "string" ? line.nyc_salespersonbid.split('/') : [];
                                  const maxLength = Math.max(customerBids.length, salespersonBids.length);
                                  return Array.from({ length: maxLength }, (_, index) => (
                                    <tr key={index} style={{ color: "#000000" }} className={index % 2 === 0 ? "bg-white" : "bg-[#FFF6F6]"}>
                                      <td style={{ borderRight: "1px solid #ccc", padding: "4px 6px" }}>
                                        {`${getOrdinal(index + 1)}`}
                                      </td>
                                      <td style={{ borderRight: "1px solid #ccc", padding: "4px" }}>
                                        {customerBids[index] || "-"}
                                      </td>
                                      <td style={{ padding: "4px" }}>
                                        {salespersonBids[index] || "-"}
                                      </td>
                                    </tr>
                                  ));
                                })()}
                              </tbody>
                            </table>
                          }
                          placement="right"
                          arrow
                        >
                          <button
                            style={{ padding: "8px", cursor: "pointer" }}
                          ><FaHistory /></button>
                        </Tooltip>
                      </td>
                    )} */}

                    {visibleColumns.includes('history') && (
                      <td className="relative group">
                        <button className="cursor-pointer text-red-600 transition duration-200">
                          <FaHistory />
                        </button>

                        <div className="absolute hidden group-hover:block top-0 right-16 left-[-12rem] bg-white border border-gray-300 rounded-lg shadow-lg p-1 z-50">
                          <table className="table-auto w-full text-left text-sm">
                            <thead className='w-full'>
                              <tr style={{ color: "#000000" }}>
                                <th style={{ padding: "4px" }}>Bid</th>
                                <th style={{ padding: "4px" }}>You</th>
                                <th style={{ padding: "4px" }}>Sales Person</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const customerBids = typeof line.nyc_customerbid === "string" ? line.nyc_customerbid.split('/') : [];
                                const salespersonBids = typeof line.nyc_salespersonbid === "string" ? line.nyc_salespersonbid.split('/') : [];
                                const maxLength = Math.max(customerBids.length, salespersonBids.length);
                                return Array.from({ length: maxLength }, (_, index) => (
                                  <tr key={index} style={{ color: "#000000" }} className={index % 2 === 0 ? "bg-white" : "bg-[#FFF6F6]"}>
                                    <td style={{ padding: "4px 6px" }}>
                                      {`${getOrdinal(index + 1)}`}
                                    </td>
                                    <td style={{ padding: "4px" }}>
                                      {customerBids[index] || "-"}
                                    </td>
                                    <td style={{ padding: "4px" }}>
                                      {salespersonBids[index] || "-"}
                                    </td>
                                  </tr>
                                ));
                              })()}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='mt-2 flex justify-between items-center'>
            <div style={{ color: statusInfo.color, fontWeight: 'bold' }}>
              {statusInfo.text}
            </div>

            {/* Conditionally hide the button and display the message */}
            <div className='mt-2 gap-2 flex justify between' >
              {quoteStatus === 219640001 && (
                <button
                  className="bg-[#DC0A0A] text-sm cursor-pointer text-white px-3 py-1.5 rounded hover:bg-[#f10707]"
                  onClick={() => handleEditOffer(quoteNumber, quoteType, quoteId, productLines)}
                >
                  Edit Offer
                </button>
              )
              }

              {/* Conditionally hide the button and display the message */}
              {quoteStatus === 219640002 ? (
                <div style={{ color: 'gray', fontStyle: 'italic' }}>
                  No action required. Salesperson will manage the process moving forward.
                </div>
              ) : (

                <button
                  className="bg-[#DC0A0A] text-sm cursor-pointer text-white px-3 py-1.5 rounded hover:bg-[#f10707]"
                  onClick={performActionBasedOnChange}
                >
                  Submit Offer
                </button>

              )}

            </div>
          </div>
        </div>
      )
      }
    </div >
  );
};

export default QuoteDetailPage